import './singlePage.scss';
import '../../components/chat/chat.scss';
import Slider from '../../components/slider/Slider';
import Map from '../../components/map/Map';
import { useNavigate, useParams, useLoaderData, Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import { useContext, useState, useEffect, Suspense} from 'react';
import { AuthContext } from '../../context/AuthContext';
import apiRequest from '../../lib/apiRequest';
import Modal from '../../components/modal/Modal';
import { Helmet } from 'react-helmet-async';
import useChatResolver from '../../lib/useChatResolver';
import SingleChat from '../../components/chat/SingleChat';
import RecommendedAds from '../../components/recommended/RecommendedAds';
import SinglePageBanner from '../../components/ads/SinglePageBanner';
import SinglePageBannerTwo from '../../components/ads/SinglePageBannerTwo';

function SinglePage() {
  const post = useLoaderData();
  const [saved, setSaved] = useState(post.isSaved);
  const [chatActive, setChatActive] = useState(false);
  const [currentChatId, setCurrentChatId] = useState(null);
  const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();

  const images =
    post.images && post.images.length > 0
      ? post.images.map((img) => ({ src: img.url, alt: 'Post Image' }))
      : [{ src: '/noproduct.webp', alt: 'No Product Image' }];

  const formatCategory = (text) => {
    return text ? text.replace(/ /g, '_') : '_';
  };

  const formatSubCategory = (text) => {
    return text ? text.replace(/ /g, '+') : '+';
  };
  //очистка описания
  function stripHtmlTags(input = '') {
  return input.replace(/<\/?[^>]+(>|$)/g, '').replace(/\s+/g, ' ').trim();
}

  const handleButtonClick = () => {
    navigate(`/edit/${post.id}`);
  };

  const handleSave = async () => {
    if (!currentUser) {
      navigate('/login');
      return;
    }
    setSaved((prev) => !prev);
    try {
      await apiRequest.post('/users/save', { postId: post.id });
    } catch (err) {
      console.log(err);
      setSaved((prev) => !prev);
    }
  };
//Chat
  const { resolveChat } = useChatResolver();
const handleChat = async () => {
  if (!currentUser) {
    navigate('/login');
    return;
  }
  try {
    const chat = await resolveChat({
      receiverId: post.userId,
      postId: post.id,
      image: post.images?.[0]?.url || '/noproduct.webp'
    });

    setCurrentChatId(chat.id);
    setChatActive(true);
  } catch (err) {
    console.error('❌ Ошибка при инициализации чата:', err.message);
  }
};
//Прокрутка вверх
const { id } = useParams();
  useEffect(() => {
  const el = document.querySelector('.navbar');
  if (el) el.scrollIntoView({ behavior: 'auto' });
}, [id]);

  //Очистка description
const cleanHtml = DOMPurify.sanitize(
  post.postDetail.desc
    .replace(/(?:\r\n|\r|\n)/g, '<br/>') // переносы
    .replace(/<a\s+href="([^"]+)"/g, '<a href="$1" rel="nofollow"') // ссылки
);


  //Очистка описания
  const cleanDesc = stripHtmlTags(post.postDetail?.desc || '').slice(0, 150);
  const cleanDescFull = stripHtmlTags(post.postDetail?.desc || '').slice(0, 200);
  //
  
  //Удаление пустого чата
  const deleteEmptyChat = async () => {
  if (!currentChatId) return; // Если чата нет, ничего не делаем
  try {
    const chatResponse = await apiRequest.get(`/chats/${currentChatId}`);

    if (!chatResponse?.data?.messages?.length) { // Проверяем, есть ли сообщения
      await apiRequest.delete(`/chats/${currentChatId}`);
      setCurrentChatId(null); // Сбрасываем состояние
    }
  } catch (err) {
    console.error("Ошибка при удалении пустого чата:", err.message);
  }
};
useEffect(() => {
  let isCancelled = false;

  if (!chatActive && !isCancelled) {
    deleteEmptyChat();
  }

  return () => {
    isCancelled = true;
  };
}, [chatActive]);

  const handleShare = () => {
    const shareData = {
      title: post.title,
      text: `${post.title}`,
      url: `https://www.naijads.ng/${post.id}`,
    };
    if (navigator.share) {
      navigator.share(shareData).catch(console.error);
    } else {
      console.log('Web Share API not supported.');
    }
  };
   // Функция форматирования цены
  const formatPrice = (price) => {
    return '₦ ' + price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  };

  useEffect(() => {
  if (post && post.title) {
    window.prerenderReady = true;
  }
}, [post]);
  return (
    <>
<Helmet>
<title>{`${post.condition} ${post.title} in ${post.city}, Nigeria`}</title>
  <link rel="canonical" href={`https://www.naijads.ng/${post.id}`} />
  <meta name="description" content={cleanDesc} />
  <meta property="og:title" content={`${post.condition} ${post.title} in ${post.city}, Nigeria`} />
  <meta property="og:description" content={cleanDesc} />
  <meta property="og:url" content={`https://www.naijads.ng/${post.id}`} />
  <meta property="og:image" content={images[0]?.src || 'https://www.naijads.ng/noproduct.webp'} />
  <meta property="og:type" content="article" />
  <meta property="og:site_name" content="Naijads.ng" />

  <meta name="twitter:card" content="summary_large_image" />
   <meta
    name="twitter:title"
    content={`${post.condition} ${post.title} in ${post.city}, Nigeria`}
  />
  <meta name="twitter:description" content={cleanDesc} />
  <meta name="twitter:image" content={images[0]?.src || 'https://www.naijads.ng/noproduct.webp'} />
  
<script type="application/ld+json">
  {JSON.stringify({
    "@context": "https://schema.org",
    "@type": "Product",
    "name": `${post.condition} ${post.title} in ${post.city}, Nigeria`,
    "description": cleanDescFull,
    "image": post.images?.[0]?.url || "https://www.naijads.ng/noproduct.webp",
    "itemCondition": `https://schema.org/${post.condition || "UsedCondition"}`,
    "offers": {
      "@type": "Offer",
      "priceCurrency": "NGN",
      "price": post.price,
      "availability": "https://schema.org/InStock",
      "url": `https://www.naijads.ng/${post.id}`
    },
    ...(post.ratingValue && post.reviewCount
      ? {
          aggregateRating: {
            "@type": "AggregateRating",
            "ratingValue": post.ratingValue,
            "reviewCount": post.reviewCount
          }
        }
      : {}),
    ...(post.user?.username
      ? {
          seller: {
            "@type": "Person",
            "name": post.user.username,
            ...(post.user.phone && { telephone: post.user.phone })
          }
        }
      : {})
  })}
</script>
</Helmet>

      <Suspense fallback={<div>Loading...</div>}>
        <div className="singlePage">
          <div className="left">
            <div className="breadCrumbs">
            <p>
              {post.category
                ?  <Link
                      to={`/category/${formatCategory(
                        post.category
                      )}?&country=${post.country}`}
                    >
                      <span>{post.category}</span>
                    </Link>
                : 'Chose category'}
              {post.subcategory && (
                <> / <Link
                      to={`/category/${formatCategory(
                        post.category
                      )}?&country=${
                        post.country
                      }&subcategory=${formatSubCategory(post.subcategory)}`}
                    >
                      <span>{post.subcategory}</span>
                    </Link></>
              )}
            </p>
          </div>
            <div className="wrapper">
              <Slider images={images} title={post.title} />
              <div className="info">
                <div className="top">
                  <div className="post">
                    <h1>{post.title}</h1>
                    <div className="address">
                      <img src="/pin.png" alt="" />
                      <span>
                        {post.country}, {post.city}, {post.region}
                      </span>
                    </div>
                    <div className="price">{formatPrice(post.price)}</div>
                  </div>
                  <div className="user">
                    {
                      <img
                        src={
                          post.user.avatar !== null
                            ? post.user.avatar.url
                            : '/noavatar.jpg'
                        }
                        alt="avatar"
                      />
                    }
                    <span>{post.user.username}</span>
                    <span className="phone">{post.user.phone}</span>
                    {currentUser !== null ? (
                      post.userId !== currentUser?.user?.id && (
                        <span className="icons">
                    <img
  onClick={handleChat}
  src="/chat.png"
  alt="chat"
/>
                        </span>
                      )
                    ) : (
                      <span className="icons">
                        <img
                          onClick={() => setChatActive(true)}
                          src="/chat.png"
                          alt=""
                        />
                      </span>
                    )}
                    <Modal active={chatActive} setActive={setChatActive}>
  <>
    <div className="modalMessageButton">
      <button className="button" onClick={() => setChatActive(false)}>X</button>
    </div>

    {currentUser ? (
      <SingleChat chatId={currentChatId} post={post} />
    ) : (
      <div className="unauthorizedChat">
        <p>🔒 Please log In to start the chat</p>
        <button onClick={() => navigate('/login')}>
          Log in
        </button>
      </div>
    )}
  </>
</Modal>
                  </div>
                </div>
              </div>
              <div
  className="bottom"
  dangerouslySetInnerHTML={{
    __html: cleanHtml,
  }}
></div>
            </div>
          </div>
          <div className="features">
            <div className="wrapper">   
              <p className="title">Details:</p>
              <div className="sizes">
                <div className="size">
                  <span>Condition:</span> <span>{post.condition}</span>
                </div>
                {Array.from({ length: 8 }).map((_, index) => {
                  const optionName = post[`option${index + 1}name`];
                  const optionValue = post[`option${index + 1}`];
                  return (
                    optionName &&
                    optionValue && (
                      <div className="size" key={index}>
                        <span>{optionName}:</span> <span>{optionValue}</span>
                      </div>
                    )
                  );
                })}
              </div>
              <p className="title">Location:</p>
              <div className="mapContainer">
                <Map items={[post]} />
              </div>
              <img
                onClick={handleShare}
                src="/upload.png"
                alt="Share"
                width="16"
                height="16"
                style={{ cursor: 'pointer' }}
              />
              {currentUser !== null && (
                <div className="buttons">
                  {post.userId !== currentUser?.user?.id && (
                    <button
                      onClick={handleSave}
                      style={{
                        backgroundColor: saved ? '#fad23bd6' : 'white',
                        border: saved ? 'none' : '1px solid #9876d4',
                      }}
                    >
                      <img src="/save.png" alt="" />
                      {saved ? 'Ad Saved' : 'Save the Ad'}
                    </button>
                  )}
                  {post.userId === currentUser?.user?.id && (
                    <button
                      onClick={handleButtonClick}
                      style={{ backgroundColor: '#fad23bd6' }}
                    >
                      <img src="/edit.png" alt="" /> {'Edit the Ad'}
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="singlePageAds">
            <SinglePageBanner /><SinglePageBannerTwo />
          </div>
        </div>
        <div className="recommended">
          <RecommendedAds />
        </div>
      </Suspense>
    </>
  );
}

export default SinglePage;
